
import React from 'react';
import { Card, CardHeader, CardDescription, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

interface PaymentStatCardsProps {
  totalPaid: number;
  pendingAmount: number;
  lastPaymentAmount: number | null;
  isLoading: boolean;
}

export const PaymentStatCards: React.FC<PaymentStatCardsProps> = ({
  totalPaid,
  pendingAmount,
  lastPaymentAmount,
  isLoading
}) => {
  if (isLoading) {
    return (
      <div className="grid gap-4 grid-cols-1 md:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i}>
            <CardHeader className="pb-2">
              <CardDescription className="text-muted-foreground">
                <div className="animate-pulse h-4 w-24 bg-muted rounded"></div>
              </CardDescription>
              <CardTitle className="text-2xl">
                <div className="animate-pulse h-6 w-16 bg-muted rounded"></div>
              </CardTitle>
            </CardHeader>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid gap-4 grid-cols-1 md:grid-cols-3">
      <Card>
        <CardHeader className="pb-2">
          <CardDescription>Оплачено всего</CardDescription>
          <CardTitle className="text-2xl">{totalPaid} ₽</CardTitle>
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardDescription>Ожидание</CardDescription>
          <CardTitle className="text-2xl">{pendingAmount} ₽</CardTitle>
        </CardHeader>
      </Card>
      
      <Card>
        <CardHeader className="pb-2">
          <CardDescription>Последний платеж</CardDescription>
          <CardTitle className="text-2xl">
            {lastPaymentAmount !== null 
              ? `${lastPaymentAmount} ₽` 
              : '0 ₽'}
          </CardTitle>
        </CardHeader>
      </Card>
    </div>
  );
};
